import Marquee from "react-fast-marquee";
import { useContent } from "@/context/ContentContext";

const Leaf = () => (
  <img src="/brand/leaf.png" alt="" aria-hidden className="h-6 w-6 shrink-0 object-contain md:h-8 md:w-8" />
);

export default function EditorialMarquee({ dark = true }) {
  const c = useContent();
  const items = c.lines("marquee", "items");
  if (!items.length) return null;
  return (
    <div
      className={`overflow-hidden border-y py-4 md:py-5 ${
        dark ? "border-pine bg-pine text-white" : "border-line bg-surface text-pine"
      }`}
      data-testid="editorial-marquee"
    >
      <Marquee speed={40} gradient={false} pauseOnHover autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-10 flex items-center gap-20">
            <span
              className={`whitespace-nowrap font-display text-3xl font-medium md:text-4xl ${
                i % 2 ? (dark ? "text-mintlight" : "text-moss") : ""
              }`}
            >
              {t}
            </span>
            <Leaf />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
